import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    // Franja inferior centrada, sin pointer-events: la barra superior (top:0) choca con la
    // topbar (botón de menú, ThemeToggle, NotificationBell) y con los toasts existentes
    // (ToastContainer de @metrodev/core-web y NotificationToastContainer), ambos top-right
    // y full-width en mobile — ver hallazgo de revisión.
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        pointerEvents: 'none',
        background: 'var(--color-info-bg)',
        color: 'var(--color-info)',
        borderRadius: 8,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 600,
        padding: '6px 14px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      Sin conexión — algunas acciones no van a estar disponibles hasta que vuelva la red
    </div>
  );
}
